<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" fill="none" viewBox="0 0 130 130">
    <g clip-path="url(#email-icon)">
      <path fill="#3E8DFF" d="M14.648 114h44.616V38.131H14.648C10.442 38.131 7 41.568 7 45.77v60.593c0 4.201 3.442 7.638 7.648 7.638z"/>
      <path fill="#8BBBFF" d="M59.264 114h44.615c4.207 0 7.648-3.437 7.648-7.638V45.769c0-4.2-3.441-7.638-7.648-7.638H59.264V114zM59.264 78.993V38.131H13.5c-6.119 0-8.923 7.638-4.079 11.33l49.842 29.532z"/>
      <path fill="#BBDAFF" d="M104.899 38.131H59.264v40.862l49.714-29.532c4.716-3.692 2.04-11.33-4.079-11.33z"/>
      <path fill="#8EDDC0" d="M122.49 36.094l-9.815-17.057c-.765-1.273-2.04-2.037-3.57-2.037H99.29v42.39h9.815c1.403 0 2.805-.764 3.57-2.037l9.943-17.185c.637-1.146.637-2.8-.128-4.074z"/>
      <path fill="#3C9" d="M99.29 17h-9.943c-1.402 0-2.804.764-3.569 2.037l-9.943 17.057c-.765 1.273-.765 2.801 0 4.074l9.943 17.185c.765 1.273 2.04 2.037 3.57 2.037h9.942V17z"/>
      <path fill="#fff" d="M102.222 46.15h-6.374l-5.099-8.4h6.374l1.912 3.054 6.501-10.565h6.374l-9.688 15.912z"/>
    </g>
    <defs>
      <clipPath id="email-icon">
          <path fill="#fff" d="M0 0H116V97H0z" transform="translate(7 17)"/>
      </clipPath>
  </defs>
  </svg>
</template>
<script>
export default {
    name:'EmailNotificationIcon'
}
</script>